import {useState, useEffect, useCallback, useRef} from 'react';
import { LineChart, Line } from 'recharts';
import * as SizeFunctions from '../utilities/SizeFunctions';
import * as ChartFunctions from '../utilities/ChartFunctions';

function compare(a, b) {
  if (a.name < b.name) {
    return -1;
  }
  if (a.name > b.name) {
    return 1;
  }
  // a must be equal to b
  return 0;
}

function App(props) {

  var itemPath = props.itemPath;
  var doAScreenRef = props.doAScreenRef;
  var className = props.className;
  var onClick = props.onClick;
  var draggable = props.draggable;
  var onDragStart = props.onDragStart;
  var onDragEnd = props.onDragEnd;
  var onMouseOver = props.onMouseOver;
  var onMouseOut = props.onMouseOut;
  var onDrag = props.onDrag;
  var allStyles = props.allStyles;
  var dataSet = props.dataSet;

  const ref1 = useRef();

  useEffect(()=>{
    doAScreenRef(ref1, itemPath);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  var dataOut = [];
  var lines = dataSet.map((aData, index)=>{
    var title = aData.cap;
    aData.dS.forEach((aPoint, index2)=>{
      if (aPoint && aPoint.date){
        var pointDate = Number(aPoint.date) * 1000;
        var pointValue = aPoint.value;
        var alreadyGot = false;

        for (var i = 0; i < dataOut.length; i++){
          if (dataOut[i].name === pointDate){
            dataOut[i][title] = pointValue;
            alreadyGot = true;
            break;
          }
        }
        if (!alreadyGot){
          var thisPt = {name:pointDate};
          thisPt[title] = pointValue;
          dataOut.push(thisPt);
        }

      }
    })
    return <Line type="monotone" connectNulls dataKey={title} stroke={aData.strokeColor} activeDot={{ r: 5 }} dot = {{ r: 0 }}/>
  })

  var data = dataOut.sort(compare);

  const [width, setWidth] = useState(1000);

  const setMainContainerHeight = useState(0)[1];
  const setMainContainerWidth = useState(0)[1];
  var pp = {reportWidth:SizeFunctions.updateSubsetDimensions(setWidth)};

  const handler = useCallback(SizeFunctions.createSizeHandler(ref1, setMainContainerHeight, setMainContainerWidth, pp),[setMainContainerHeight, setMainContainerWidth, pp]);  
  SizeFunctions.useEventListener('resize', handler);
  useEffect(() =>{SizeFunctions.createSizeEffect(ref1, setMainContainerHeight, setMainContainerWidth, pp);}, [setMainContainerHeight, setMainContainerWidth, pp])

  var timeType = 'Time';
  var formatXAxis = function(x){
    var xx = (new Date(x)).toString();
    return xx.substr(16, 5); 
  }
  if (data.length > 1){
    var firstTime = data[0].name;
    var lastTime = data[data.length - 1].name;
    if (lastTime - firstTime > 365 * 1000 * 24 * 60 * 60){
      timeType = 'Date';
      formatXAxis = function(x){
        var xx = (new Date(x)).toString();
        var firstPart = xx.substr(0, 15);
        var firstArray = firstPart.split(' ');
        return firstArray[1] + ' ' + firstArray[3].substr(2);
      }
    }else if (lastTime - firstTime > 1000 * 24 * 60 * 60){
      timeType = 'Date';
      formatXAxis = function(x){
        var xx = (new Date(x)).toString();
        var firstPart = xx.substr(0, 15);
        var firstArray = firstPart.split(' ');
        return firstArray[2] + ' ' + firstArray[1]; 
      }
    }
  }

  var stdPieces = ChartFunctions.getStdPieces(allStyles, formatXAxis, timeType, data);
  return (<div ref={ref1} className={className} draggable={draggable} onClick={onClick} onDragStart={onDragStart} onDrag={onDrag} onDragEnd={onDragEnd} onMouseOver={onMouseOver} onMouseOut={onMouseOut} >

      <LineChart
        fontSize={allStyles.fontSize}
        width={width}
        height={width * 0.6}
        data={data}
        margin={{
          top: 5,
          right: 40,
          left: 0,
          bottom: 5,
        }}
      >
        {stdPieces}
        {lines}
      </LineChart>
      </div>

      
  );


}


export default App;